import { render } from "./SignUpOTP.vue?vue&type=template&id=1ec6233a&ts=true"
import script from "./SignUpOTP.vue?vue&type=script&lang=ts"
export * from "./SignUpOTP.vue?vue&type=script&lang=ts"

import "./SignUpOTP.vue?vue&type=style&index=0&id=1ec6233a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__